import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'

import { AppService } from '@@services/app.service'
import { environment } from 'src/environments/environment'

@Component({
    standalone: false,
    selector: 'app-company-finder',
    templateUrl: './company-finder.component.html',
    styleUrls: ['./company-finder.component.scss']
})
export class CompanyFinderComponent implements OnInit {
    searchData: any
    tenantsOnline: any

    constructor(
        private router: Router,
        private appService: AppService
    ) {}

    ngOnInit() {
        this.appService.getOnlineTenants().subscribe((res) => {
            this.tenantsOnline = res.list
        })
    }

    chooseTenant(tenant: any) {
        const bookingUrl = environment.bookingBaseUrl + '/book/schedule/' + tenant.onlineBookingId + '/classes'
        window.open(bookingUrl, '_blank')
    }
}
